import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import "./style.scss";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import Pagination from "react-js-pagination";
import { Button as MaterialButton } from "@material-ui/core";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import { Country, State, City } from "country-state-city";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";

import mentorIcon from "../../../../../assets/svg/dashboard/Mentor-iconCircle.svg";
import CohortDetail from "../../../../../assets/svg/dashboard/Cohort-Details.svg";
import SubmitAction from "../../../SubmitAction";
import axios from "axios";
import excelButton from "../../../../../assets/images/maargThemeXls2.png";
import {
  COHORT_NAME_LIST,
  DOWNLOAD_EXCEL_COHORT,
} from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";

// import {
//   getStartupApplication,
//   getCountersStartUpList,
// } from "../dependencies/action";
import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as moment from "moment";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import Select from "react-select";
import Button from "../../AdminDashboard/Button";
import {
  getNamesList,
  setAdminCohortAppStatus,
  getCohortApplicationCounter,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { getMentorCohortApplicationList } from "../../MentorDashboard/dependencies/action";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
import * as CryptoJS from "crypto-js";
const CohortApplication = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const html = document.getElementsByTagName("html")[0];
  const {
    getNamesList,
    getNamesListData,
    getTableDataPaginate,
    getTableData,
    getMentorCohortApplicationList,
    setAdminCohortAppStatus,
    getTableCounterData,
    getStepperTooltipData,
    getStepperData,
  } = props;
  // const imageUrl = "https://uat-nmp-api.startupindia.gov.in/v1/document/;";
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [activeText, setActiveText] = useState(false);
  const [activeText0, setActiveText0] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");

  const [mentorShipReqData, setMentorShipReqData] = useState();
  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const history = useHistory();
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");

  const defaultFormData = {
    search: "",
    cohortorgname: "",
    cohortId: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };

  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [allMentorNames, setAllMentorNames] = useState();

  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [showSubmitAction, setShowSubmitAction] = useState(false);
  const [approvaloption, setApprovalOption] = useState();
  const [submitData, setSubmitData] = useState();
  const [action, setAction] = useState();
  const [cohortnameList, setcohortnameList] = useState([]);
  const [cohortnameId, setcohortnameId] = useState([]);
  const [filterCohortname, setFilterCohortname] = useState("");
  const [filterCohortId, setFilterCohortId] = useState("");
  const [cohortfilterGo, setcohortfilterGo] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const {
    getStartupApplication,
    startUpApplication,
    startUpApplicationPagineate,
    getCountersStartUpList,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
    getCohortApplicationCounter,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  if (loginrole === "Admin") {
    localStorage.setItem("cohortApplication", "cohortApplication");
  } else {
    localStorage.removeItem("cohortApplication");
    history.push("/startup-dashboard");
  }
  useEffect(() => {
    html.style.overflow = "auto";

    // localStorage.setItem("cohortApplication", "cohortApplication");
    setTimeout(() => {
      // localStorage.removeItem("activitySummary");
      localStorage.removeItem("allMentorList");
      localStorage.removeItem("allMentorsMentorship");
      localStorage.removeItem("allStartupList");
      localStorage.removeItem("allMentorships");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("mentorMenu");
      localStorage.removeItem("startupMentorAllMentorships");
      localStorage.removeItem("startUpApplications");
    }, 1000);
    // getAllData()
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     status: "VERIFIED",
    //     // mentorId:
    //     //   localStorage.getItem("SavedLoggedInData") &&
    //     //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        status: "VERIFIED",
        // mentorId:
        //   localStorage.getItem("SavedLoggedInData") &&
        //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        const cohortnameArray = [];

        // setCounterData(res.data?.data)
        res.data.data &&
          res.data.data.map((item, index) => {
            // const params = {
            //   label: item.name,
            //   value: item.id,
            // };
            // cohortnameArray.push(params);
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Name",
                value: "select",
              };
              setcohortnameList((oldArray) => [...oldArray, arr2]);
            }
            let arr = {
              label: item.name,
              value: item.id,
            };
            if (res.data.data.length >= cohortnameList.length)
              setcohortnameList((oldArray) => [...oldArray, arr]);
          });

        // setcohortnameList(cohortnameArray);
        // setcohortnameId(cohortidArray);
      })
      .catch((err) => {});

    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     status: "VERIFIED",
    //     // mentorId:
    //     //   localStorage.getItem("SavedLoggedInData") &&
    //     //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        status: "VERIFIED",
        // mentorId:
        //   localStorage.getItem("SavedLoggedInData") &&
        //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        // const cohortnameArray = [];
        const cohortidArray = [];

        res.data.data &&
          res.data.data.map((item, index) => {
            // const params = {
            //   label: `C${item.id.slice(-6)}`,
            //   value: item.id,
            // };
            // cohortidArray.push(params);
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Id",
                value: "select",
              };
              setcohortnameId((oldArray) => [...oldArray, arr2]);
            }
            let arr = {
              label: `C${item.id.slice(-6)}`,
              value: item.id,
            };
            if (res.data.data.length >= cohortnameId.length)
              setcohortnameId((oldArray) => [...oldArray, arr]);
          });

        // setcohortnameList(cohortnameArray);
        // setcohortnameId(cohortidArray);
      })
      .catch((err) => {});
  }, []);
  // useEffect(() => {
  //   document.addEventListener("visibilitychange", function () {
  //     if (document.hidden) {
  //     } else {
  //       window.location.reload();
  //     }
  //   });
  // }, []);
  useEffect(() => {
    if (props?.location?.state?.requestStatus === undefined || props.location?.state?.requestStatus === "viewAll") {
      getTableDataStatus3("")
      setActiveText(true);
    } else if (props?.location?.state?.requestStatus === "pending") {
      setActiveText2(true);
      getTableDataStatus3("SUBMITTED")
    } else {setActiveText(true); getTableDataStatus3("")}
  }, []);
  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    counterList();
  }, []);
  const counterList = () =>{
    let params = {};
    getCohortApplicationCounter(params);
  }
  const getTableDataStatus3 = (status) => {
    let params = {
      cohortId: filterCohortId == "select" ? "" : filterCohortId,
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry: filterIndustry == "select" ? "" : filterIndustry,
      function: filterFunction == "select" ? "" : filterFunction,
      stage: filterStage == "select" ? "" : filterStage,
      searchField: "",
      searchKey: null,
      status: status,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  };
  const getTableDataStatus2 = (status) => {
    let params = {
      cohortId: filterCohortId == "select" ? "" : filterCohortId,
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry: filterIndustry == "select" ? "" : filterIndustry,
      function: filterFunction == "select" ? "" : filterFunction,
      stage: filterStage == "select" ? "" : filterStage,
      searchField: "",
      searchKey: null,
      status: selectedStatus,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  };
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    //
    //
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);

  useEffect(() => {
    let nameArrList = [];

    getNamesListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Startup",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (getNamesListData.length >= nameListValue.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [getNamesListData]);
  useEffect(() => {
    // let params = {
    //   cohortId: filterCohortId == "select" ? "" : filterCohortId,
    //   sortKey: "name",
    //   sortOrder: "ASC",
    //   country: null,
    //   state: null,
    //   industry: filterIndustry == "select" ? "" : filterIndustry,
    //   function: filterFunction == "select" ? "" : filterFunction,
    //   stage: filterStage == "select" ? "" : filterStage,
    //   searchField: "",
    //   searchKey: null,
    //   pageFilter: {
    //     currentPage: 0,
    //     includeCount: true,
    //     pageSize: 10,
    //     sortField: "date_applied",
    //     sortOrder: "DESC",
    //   },
    // };
    // getMentorCohortApplicationList(params);
    //
  }, [cohortfilterGo]);
  const getTableDataStatus = (status) => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry: null,
      function: null,
      stage: null,
      searchField: "",
      searchKey: null,
      status: status,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  };

  const approvalOptions = [
    {
      value: "Approve",
      label: "Approve",
    },
    { value: "Reject", label: "Reject" },
    { value: "Request Info", label: "Request Info" },
  ];
  const tempVar = {
    no: "1",
    name: "Sample Cohort",
    appID: "A21232",
    appDate: "29-08-2022",
    cohortID: "C14698",
    appStatus: "",
    comments: "Sample Comment",
  };
  const newList = [];
  newList.push(tempVar);
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);
  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      minHeight: "47px",
      color: "#333",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        textAlign: "left",
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  // const customStyles = {
  //   option: (provided, state) => ({
  //     ...provided,
  //     minWidth:"50px",
  //     textAlign: "left",
  //   }),
  //   menu: (base) => ({
  //     ...base,
  //     width: "max-content",
  //     minWidth: "100%",
  //     fontSize: "14px",
  //   }),
  //   container: provided => ({
  //     ...provided,
  //     minWidth:"47px",
  //   })
  // };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  // useEffect(() => {
  //   if (
  //     history?.location?.state?.fromModule !== undefined &&
  //     history?.location?.state?.fromModule === "cohortApplicationPending"
  //   ) {
  //     // getStartupApplicationTable("PENDING");

  //     setActiveText2(true);
  //     setActiveText(false);
  //     setActiveText3(false);
  //     setActiveText4(false);
  //     let params = {
  //       sortKey: "name",
  //       sortOrder: "ASC",
  //       country: null,
  //       state: null,
  //       industry: null,
  //       function: null,
  //       stage: null,
  //       searchField: "",
  //       searchKey: null,
  //       status: "SUBMITTED",
  //       pageFilter: {
  //         currentPage: 0,
  //         includeCount: true,
  //         pageSize: 10,
  //         sortField: "date_applied",
  //         sortOrder: "DESC",
  //       },
  //     };
  //     getMentorCohortApplicationList(params);
  //   } else {
  //     let params = {
  //       sortKey: "name",
  //       sortOrder: "ASC",
  //       country: null,
  //       state: null,
  //       industry: null,
  //       function: null,
  //       stage: null,
  //       searchField: "",
  //       searchKey: null,
  //       status: "",
  //       pageFilter: {
  //         currentPage: 0,
  //         includeCount: true,
  //         pageSize: 10,
  //         sortField: "date_applied",
  //         sortOrder: "DESC",
  //       },
  //     };
  //     getMentorCohortApplicationList(params);
  //     // getStartupApplicationTable("");
  //   }
  // }, []);
  const onclickShowSubmitAction = (action, id, status) => {
    setShowSubmitAction(true);
    setAction(action);
    let params = {
      id: id,
      status: status,
    };
    setSubmitData(params);
  };
  const clickOnClose = () => {
    setShowSubmitAction((x) => !x);
    setShowSubmitAction(!showSubmitAction);
    setApprovalOption("Select");
    localStorage.setItem("cohortApplication", "cohortApplication");
    window.location.reload();
  };
  const ViewApplicationCohort = (item) => {
    let reRoute = window.open(`/view-CohortApplication/${item}`, "_blank");
    reRoute.id = item;
    reRoute.fromModule = "ViewApplicationCohort";
    // history.push({
    //   pathname: "/view-StartupApplication",
    //   state: dpiitNo
    //   // { data: item, prevPage: "startUpList" },
    // });
  };
  const redirectProfile = (dpiitNo) => {
    let reRoute = window.open(sample + "/startup-profile", "_blank");
    reRoute.id = dpiitNo;
    // history.push({
    //   pathname: "/startup-profile",
    //   state: dpiitNo,
    //   // state: { data: props.history.location.state, prevPage: "startUpDash" },
    // });
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      requestedBy: "",
      status: selectedStatus,
      pageFilter: {
        currentPage: pageNumber - 1,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: filterNameValue == "Select" ? "" : filterNameValue,
      searchKey: null,
      country: "",
      // cohortId: formData.cohortorgname || formData.cohortId,
      // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      state: formData.state == "select" ? null : formData?.state?.value, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getMentorCohortApplicationList(params);
  };
  // useEffect(() => {
  //   let params = {
  //     requestedBy: "",
  //   };
  //   getCountersStartUpList(params);
  // }, []);
  const getStartUpId = (string) => {
    const value = string.substring(string?.length - 6);
    return value;
  };

  const ViewProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
    //
    // history.push({
    //   pathname: `/mentor-profile/${item.email}`,
    //   state: { prevPage: "mentorPage",data:item },
    // });
  };
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);
  return (
    <>
      <div className="chrtappliadminmainfirstdiv">
        <div
          className="dashboard-main2 admindashcohortapplimaindiv"
          style={{ background: "none" }}
        >
          <div
            className="dashboard-bottom-btn4 topbackbtnmentorlist"
            style={{ background: "transparent", border: "none" }}
          >
            {/* <div className="newuserTooltip">
              <MaterialButton
                className="topbackbtnactual top-btn"
                variant="contained"
                color="primary"
                onClick={() => {
                  localStorage.setItem(
                    "mentorDashboardHome",
                    "mentorDashboardHome"
                  );
                  localStorage.removeItem("cohortApplication");

                  window.location.reload();
                }}
                style={{ background: "#3ac2d7" }}
              >
                {" "}
                Back
              </MaterialButton>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  top: "69px",
                  width: "200px",
                  left: "71px",
                }}
              >
                Click to Go My Dashboard
              </span>
            </div> */}
            <Modal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              modalData={modalData}
            />
          </div>
          <div className="iconWith-heading admindashcohortappliappwith">
            <div style={{ width: "100%" }} className="mainhead">
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                ADMIN DASHBOARD: COHORT APPLICATIONS
              </h3>
            </div>
            <a href={DOWNLOAD_EXCEL_COHORT}>
              <div className="newuserTooltip">
                <img
                  className="excelButton"
                  src={excelButton}
                  style={{ top: "2rem", width: "47%", left: "0rem" }}
                ></img>
                <span
                  className="tooltiptext   tooltip-bottom admincohort01"
                  style={{ left: "-1rem", top: "5.5rem", width: "12vw" }}
                >
                  Download Excel Report
                </span>
              </div>
            </a>
            <div
              className="tooltipshow eyeIcon"
              onClick={() => {
                // html.style.overflow = "hidden";

                if (html.style.overflow == "auto") {
                  html.style.overflow = "hidden";
                } else {
                  html.style.overflow = "auto";
                }
              }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={setModalIsOpenToTrue}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
              {isShown && (
                <div>
                  <AnimeList
                    setModalIsOpenToTrue={setModalIsOpenToTrue}
                    Heading={Heading}
                    InstructionswithRole={InstructionswithRole}
                    SelectPage={SelectPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="col-md-11 display-center mobileviewcohortappli">
          <div className="admin-bottom-cardNew row mobileviewmentorbelow">
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 mentorAppButton">
              <div className="dashboard-bottom-btn2">
                <p className="text-white2"> APPLICATION STATUS</p>
              </div>
            </div>
            <div className="col-xs-6 col-sm-6 col-md-1 col-lg-1 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText0(true);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  getTableDataStatus("DRAFT");
                  setSelectedStatus("DRAFT");
                  // getStartupApplicationTable("");
                }}
                style={{
                  color: activeText0 ? "#277acc" : "#838186",
                }}
                className="admindasheaderoptions applicationHeading004 admincohortappli45"
              >
                DRAFTS : {getTableCounterData && getTableCounterData.draft}
                {/* {getCounterStartUp && getCounterStartUp.totalSearch !== null
                  ? getCounterStartUp.totalSearch
                  : 0} */}
              </p>
              <span className="tooltiptext   tooltip-bottom admincohort01">
                Click to View Draft Applications
              </span>
              {activeText0 ? (
                <img
                  className="requestStatusBar statusBarLine2"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText0(false);
                  setActiveText(true);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  getTableDataStatus("");
                  setSelectedStatus("");
                  // getStartupApplicationTable("");
                }}
                style={{
                  color: activeText ? "#277acc" : "#838186",
                }}
                className="admindasheaderoptions applicationHeading4 admincohortappli45"
              >
                TOTAL <br></br>RECEIVED :{" "}
                {getTableCounterData && Math.abs(getTableCounterData.total)}
                {/* {getCounterStartUp && getCounterStartUp.totalSearch !== null
                  ? getCounterStartUp.totalSearch
                  : 0} */}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "-50px", width: "270px" }}
              >
                Click to View Total Received Applications
              </span>
              {activeText ? (
                <img
                  className="requestStatusBar statusBarLine"
                  src={LineWithDot}
                  style={{ minWidth: "9rem", left: "-4.3rem" }}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText0(false);
                  setActiveText2(true);
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setSelectedStatus("SUBMITTED");
                  getTableDataStatus("SUBMITTED");
                  // getStartupApplicationTable("PENDING");
                  // getMentorApplications("PENDING");
                }}
                style={{ color: activeText2 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions applicationHeading4 admincohortappli45"
              >
                {" "}
                PENDING <br></br> APPROVAL :{" "}
                {getTableCounterData && Math.abs(getTableCounterData.pending)}
                {/* {getCounterStartUp && getCounterStartUp.pending !== null
                  ? getCounterStartUp.pending
                  : 0} */}
              </p>
              <span className="tooltiptext   tooltip-bottom admincohort03">
                Click to View Pending Approval Applications
              </span>
              {activeText2 ? (
                <img
                  className="requestStatusBar positionBar"
                  src={LineWithDot}
                  style={{ minWidth: "9rem", left: "-2.3rem" }}
                />
              ) : (
                ""
              )}
            </div>

            {/* <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText0(false);
                  setActiveText2(true);
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setSelectedStatus("SUBMITTED");
                  getTableDataStatus("SUBMITTED");
                 
                }}
                style={{ color: activeText2 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions applicationHeading4"
              >
                {" "}
                REQUESTED <br></br> INFO :{" "}
                {getTableCounterData && Math.abs(getTableCounterData.pending)}
               
              </p>
              <span className="tooltiptext   tooltip-bottom admincohort03">
                Click to View Requested info Applications
              </span>
              {activeText2 ? (
                <img
                  className="requestStatusBar positionBar"
                  src={LineWithDot}
                  style={{ minWidth: "9rem", left: "-2.3rem" }}
                />
              ) : (
                ""
              )}
            </div> */}
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1  newuserTooltip ">
              <p
                onClick={() => {
                  setActiveText0(false);
                  setActiveText3(true);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText4(false);
                  getTableDataStatus("APPROVED");
                  setSelectedStatus("APPROVED");
                }}
                style={{ color: activeText3 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions applicationHeading4 admincohortappli45"
              >
                {" "}
                APPROVED :{" "}
                {getTableCounterData && Math.abs(getTableCounterData.approved)}
              </p>
              <span className="tooltiptext   tooltip-bottom admincohort02">
                Click to View Approved Applications
              </span>
              {activeText3 ? (
                <img
                  className="requestStatusBar statusBarLine"
                  style={{ minWidth: "7rem", left: "-2.3rem" }}
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1  newuserTooltip ">
              <p
                onClick={() => {
                  setActiveText0(false);
                  setActiveText3(false);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText4(true);
                  // getStartupApplicationTable("REJECTED");
                  setSelectedStatus("REJECTED");
                  getTableDataStatus("REJECTED");
                  // getMentorApplications("VERIFIED");
                }}
                style={{ color: activeText4 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                REJECTED : {getTableCounterData && getTableCounterData.rejected}
                {/* {getCounterStartUp && getCounterStartUp.rejected !== null
                  ? getCounterStartUp.rejected
                  : 0} */}
              </p>
              <span className="tooltiptext   tooltip-bottom rejectappl">
                Click to View Rejected Applications
              </span>
              {activeText4 ? (
                <img
                  className="requestStatusBar statusBarLine"
                  style={{ minWidth: "7rem", left: "-0.3rem" }}
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="filter-row filter-row-common filterDivMentorapp">
            {/* <div className="container"> */}
            <div>
              <form className="formContainer newfilterdivnow">
                <div className="row desktopFilterRow">
                  {/* <div
                      className="col-md-1 filter-text3"
                      style={{
                        alignItems: "center",
                        display: "flex",
                        color: "#838186",
                        fontWeight: "400",
                        height: "40px",
                        fontSize: "18px",
                      }}
                    >
                      Filter by
                    </div> */}
                  <div className="col-11 d-flex justify-content-between filter-bigDiv">
                    {/* <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.name);
                          setFilterNameValue(e.value);
                          
                          // getStartUpListDataNameSearch(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search StartUp"
                      />
                    </div> */}
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="cohortorgname"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortorgname"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortorgname}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortorgname: e.value == "select" ? null : e,
                            };
                          });
                          // setFilterCohortname(e.value);
                          setFilterCohortId(e.value); // localStorage.setItem("cohortorgname", e.value);
                        }}
                        options={cohortnameList}
                        placeholder="Cohort Name"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "52px", width: "150px" }}
                      >
                        Search Cohort Name
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="cohortId"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortId"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortId}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortId: e.value == "select" ? null : e,
                            };
                          });
                          setFilterCohortId(e.value);
                        }}
                        options={cohortnameId}
                        placeholder="Cohort ID"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "51px", width: "130px" }}
                      >
                        Search Cohort ID
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "51px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "51px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip ">
                      <Select
                        required={true}
                        id="stage"
                        // label="Gender*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "51px", width: "130px" }}
                      >
                        Search Stage
                      </span>
                    </div>
                    {/* 
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2">
                      <Select
                        required={true}
                        id="state"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              state: e.value == "select" ? null : e,
                            };
                          });
                          setFilterState(e.value);
                        }}
                        options={newStateOptions}
                        placeholder="State"
                      />
                    </div> */}
                  </div>

                  <div className="apply-section d-flex justify-content-end col-1 newuserTooltip">
                    <Button
                      // style={{
                      //   background: "#277acc",
                      // }}
                      // onClick={handleClickOfFilter}
                      // onClick={() => setcohortfilterGo(false ? true : false)}
                      onClick={getTableDataStatus2}
                      text="GO"
                      className="filter-button top-btn newcoloredbtn startupColorBtn"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "46px",
                        width: "126px",
                        height: "48px",
                        top: "42px",
                      }}
                    >
                      Click to Apply Filters
                    </span>
                    {/* <Button
                      icon={<img src={arrow} className="search-icon" />}
                      text=""
                      onClick={() => getMentorApplications(selectedStatus)}
                      className="green-btn filter-btn apply-admin-dashbtn newfilterBtnallmentor"
                    /> */}
                  </div>
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-md-1 filter-text">Filter by</div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortorgname"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortorgname"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.cohortorgname}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortorgname: e.value == "select" ? null : e,
                          };
                        });
                        // setFilterCohortname(e.value);
                        setFilterCohortId(e.value); // localStorage.setItem("cohortorgname", e.value);
                      }}
                      options={cohortnameList}
                      placeholder="Cohort Name"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortId"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortId"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.cohortId}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortId: e.value == "select" ? null : e,
                          };
                        });
                        setFilterCohortId(e.value);
                      }}
                      options={cohortnameId}
                      placeholder="Cohort ID"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput admindashchrtappliindustrymobile"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>

                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      onClick={getTableDataStatus2}
                      // onClick={() => getStartupApplicationTable(selectedStatus)}
                      text="GO"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="totalTableCount">
            Total Cohort Applications Found :{" "}
            {getTableDataPaginate?.totalElements} &lt;{" "}
            {getTableDataPaginate?.currentPage} of{" "}
            {getTableDataPaginate?.numPages} &gt;{" "}
            {/* Total Mentors Found: {startUpApplicationPagineate?.totalElements?.data}{" "}
            &lt;
            {startUpApplicationPagineate?.currentPage?.data} of{" "}
            {startUpApplicationPagineate?.numPages?.data} &gt;{" "} */}
          </div>
          {getTableData && getTableData?.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered admincohrtapplitable">
                  <thead>
                    <tr>
                      <th
                        style={{ verticalAlign: "middle" }}
                        className="fixColumbnWidth4"
                      >
                        {" "}
                        <div>NO.</div>
                      </th>
                      <th
                        className="fixColumbnWidth"
                        colspan="2"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div>COHORT DETAILS</div>
                      </th>
                      {/* <th
                        className="fixColumbnWidth4"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",
                          }}
                        >
                          DPIIT ID
                        </div>
                      </th> */}
                      <th
                        className="fixColumbnWidth4"
                        style={{
                          whitespace: "nowrap",
                          fontSize: "15.3px",
                          minWidth: "9.4rem",
                          maxWidth: "9.5rem",
                          verticalAlign: "middle",
                        }}
                      >
                        <div>
                          APPLICATION ID <br />& DATE
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth4"
                        style={{
                          whitespace: "nowrap",
                          fontSize: "15.3px",
                          minWidth: "9.4rem",
                          maxWidth: "9.5rem",
                          verticalAlign: "middle",
                        }}
                      >
                        <div>COHORT CREATED BY</div>
                      </th>
                      <th
                        className="fixColumbnWidth4"
                        style={{
                          whitespace: "nowrap",
                          fontSize: "15.3px",
                          minWidth: "7.4rem",
                          maxWidth: "9.5rem",
                          verticalAlign: "middle",
                        }}
                      >
                        <div>COHORT ID</div>
                      </th>

                      {/* <th className="fixColumbnWidth4">MATCH TABLE</th> */}
                      <th
                        className="fixColumbnWidth7"
                        style={{
                          minWidth: "5.9rem",
                          maxWidth: "6rem",
                          verticalAlign: "middle",
                        }}
                      >
                        <div>APPLICATION STATUS</div>
                      </th>
                      {/* <th className="fixColumbnWidth7">REQUEST DATE</th> */}
                      <th
                        className="fixColumbnWidth7"
                        style={{
                          minWidth: "10.9rem",
                          maxWidth: "11rem",
                          verticalAlign: "middle",
                        }}
                      >
                        <div>COMMENTS</div>
                      </th>
                      {/* <th className="fixColumbnWidth7">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",
                          }}
                        >
                          MENTOR REQUEST STATUS
                        </div>
                      </th> */}
                    </tr>
                  </thead>
                  {getTableData &&
                    getTableData?.length > 0 &&
                    getTableData.map((item, index) => (
                      <tbody>
                        <tr
                          className={
                            item.id === selectedRow ? "purpleBackground" : ""
                          }
                          key={index}
                        >
                          <td style={{ verticalAlign: "middle" }}>
                            {getTableDataPaginate.currentPage === 1 ? (
                              // <td>
                              //   {" "}
                              <div>{index + 1}</div>
                            ) : (
                              // </td>
                              // <td>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "left",
                                  alignItems: "center",
                                  height: "100px",
                                }}
                              >
                                {index +
                                  1 +
                                  10 * (getTableDataPaginate.currentPage - 1)}
                              </div>
                              // </td>
                            )}
                          </td>
                          <td
                            style={
                              {
                                // display: "flex",
                                // justifyContent: "center",
                              }
                            }
                            className="mentornmedivmain"
                          >
                            <div
                              className="newuserTooltip"
                              style={{
                                width: "100px",
                                height: "100px",
                                maxWidth: "none",

                                objectFit: "contain",
                              }}
                            >
                              <img
                                src={
                                  item.uploadBanner === null
                                    ? hashImage
                                    : item.uploadBanner
                                }
                                onClick={
                                  () =>
                                    window.open(
                                      `/cohort-programs/all/${item?.id}`,
                                      "_blank"
                                    )
                                  // history.push(`/cohort-programs/all/${item?.id}`)
                                }
                                className="sidebar-dashboard-icon2"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "40px",
                                  top: "88px",
                                  width: "170px",
                                }}
                              >
                                {item.applicationStatus === "VERIFIED"
                                  ? "View Cohort Details"
                                  : "Cohort Preview"}
                              </span>
                              <div
                                style={{
                                  cursor: "default",
                                  alignItems: "center",
                                  display: "flex",
                                  textAlign: "right",
                                  // minWidth: "200px",
                                }}
                                className="chrtdetailsdiv0"
                              >
                                {item.program_name}
                                <br></br>
                                {item.organization_name}
                                <br></br>
                                {item?.cohort_date ? (
                                  <>
                                    Start Date:{" "}
                                    {moment(item?.cohort_date).format(
                                      "DD/MM/YYYY"
                                    )}
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                Duration: {item.program_duration}
                                <br></br>
                              </div>
                              {item.applicationStatus === "VERIFIED" ? (
                                <div
                                  className="newuserTooltip chrtdetailsiconmobile"
                                  style={{
                                    cursor: "pointer",
                                    alignItems: "end",
                                    // justifyContent: "center",

                                    minWidth: "40px",
                                    display: "flex",
                                  }}
                                >
                                  <img
                                    src={CohortDetail}
                                    onClick={() =>
                                      window.open(
                                        `/cohort-programs/all/${item?.cohortId}`,
                                        "_blank"
                                      )
                                    }
                                    width="40px"
                                    height="40px"
                                  />
                                  <span
                                    className="tooltiptext tooltip-bottom "
                                    style={{
                                      left: "10px",
                                      top: "125px",
                                      width: "150px",
                                    }}
                                  >
                                    {item.applicationStatus === "VERIFIED"
                                      ? "View Cohort Details"
                                      : "Cohort Preview"}
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </td>
                          <td className="mentoriddesktd">
                            <div
                              style={{
                                flexDirection: "row",
                                display: "flex",
                                justifyContent: "space-between",
                                height: "auto",
                              }}
                            >
                              <div
                                style={{
                                  cursor: "default",
                                  alignItems: "center",
                                  display: "flex",
                                  // minWidth: "200px",
                                }}
                                className="chrtdetailsdiv"
                              >
                                {item.program_name}
                                <br></br>
                                {item.organization_name}
                                <br></br>
                                {item?.cohort_date ? (
                                  <>
                                    Start Date:{" "}
                                    {moment(item?.cohort_date).format(
                                      "DD/MM/YYYY"
                                    )}
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                Duration: {item.program_duration}
                                <br></br>
                              </div>
                              {item.applicationStatus === "VERIFIED" ? (
                                <div
                                  className="newuserTooltip"
                                  style={{
                                    cursor: "pointer",
                                    alignItems: "end",
                                    justifyContent: "center",

                                    minWidth: "40px",
                                    display: "flex",
                                  }}
                                >
                                  <img
                                    src={CohortDetail}
                                    onClick={() =>
                                      window.open(
                                        `/cohort-programs/all/${item?.cohortId}`,
                                        "_blank"
                                      )
                                    }
                                  />
                                  <span
                                    className="tooltiptext tooltip-bottom "
                                    style={{
                                      left: "10px",
                                      top: "125px",
                                      width: "150px",
                                    }}
                                  >
                                    {item.applicationStatus === "VERIFIED"
                                      ? "View Cohort Details"
                                      : "Cohort Preview"}
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "left",
                              }}
                              className="appliidanddatemobilediv"
                            >
                              <div
                                className="newuserTooltip"
                                // style={{ marginBottom: "-15px" }}
                              >
                                <a
                                  onClick={() => {
                                    ViewApplicationCohort(item.id);
                                    // setIndexCounter(index.id);
                                    // ViewMentorApplicaiton(item?.dpiitNumber)
                                    // ViewMentorApplicaiton(item);
                                  }}
                                  // href="#"
                                  className="color-green"
                                >
                                  {" "}
                                  {item.id !== null &&
                                    item.id !== "" &&
                                    "A" + item.id.substring(item.id.length - 6)}
                                </a>
                                <span
                                  className="tooltiptext  tooltip-bottom"
                                  style={{ width: "182px", left: "8px" }}
                                >
                                  View Cohort Application
                                </span>
                              </div>
                              <br />

                              {moment(item?.date_applied).format("DD/MM/YYYY")}
                              <br></br>
                              {moment(item?.date_applied).format("hh:mm a")}
                            </div>
                          </td>
                          <td
                            style={{
                              verticalAlign: "middle",
                              position: "relative",
                            }}
                            className="chrtcreatedbytddiv"
                          >
                            <div
                              className=""
                              style={{
                                display: "flex",
                              }}
                            >
                              <div
                                className="chrtcretdchrtappli"
                                style={{
                                  justifyContent: "left",
                                  display: "flex",
                                  height: "100%",
                                }}
                              >
                                {item.mentor_name}
                                <br />
                                {item.mentorId !== null && item.mentorId !== ""
                                  ? "M" +
                                    item.mentorId.substring(
                                      item.mentorId.length - 6
                                    )
                                  : ""}
                              </div>

                              <div
                                className="newuserTooltip chrtcreatedbydivmbl"
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "0px",
                                  bottom: "0px",
                                  padding: "10px",
                                }}
                              >
                                <img
                                  src={mentorIcon}
                                  height={40}
                                  width={40}
                                  onClick={() =>
                                    ViewProfile(
                                      item?.mentorEmail,
                                      item?.mentorId
                                    )
                                  }
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "20px",
                                    top: "56px",
                                    width: "150px",
                                  }}
                                >
                                  View Mentor Profile
                                </span>
                              </div>
                            </div>
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <div className="chrtidchrtappliadmn">
                              {item.applicationStatus === "VERIFIED"
                                ? item.cohortId !== null &&
                                  item.cohortId !== "" &&
                                  "C" +
                                    item.cohortId.substring(
                                      item.cohortId.length - 6
                                    )
                                : ""}
                            </div>

                            <br />
                            {/* <div className="mt-1">
                              {moment(item?.date_applied).format("DD/MM/YYYY")}
                              <br></br>
                              {moment(item?.date_applied).format("hh:mm a")}
                            </div> */}
                          </td>

                          <td
                            style={{
                              minWidth: "9.9rem",
                              // maxWidth: "10rem",
                              alignItems: "center",
                              verticalAlign: "middle",
                            }}
                            className="appiddatedivchrtappli"
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                              className="appiddatedivchrtappliunder"
                            >
                              <div
                                className="newuserTooltip"
                                style={{
                                  display: "flex",
                                  justifyContent: "left",
                                  alignItems: "center",
                                  height: "auto",
                                }}
                              >
                                {item.applicationStatus === "SUBMITTED" ? (
                                  <>
                                    <Select
                                      required={true}
                                      id="Status"
                                      variant="outlined"
                                      fullWidth
                                      margin="normal"
                                      type="State"
                                      name="Status"
                                      className="col-12 "
                                      styles={customStyles}
                                      isSearchable={false}
                                      // value={filterData6}
                                      value={
                                        item.applicationStatus === "REQUESTINFO"
                                          ? {
                                              label: "Request Info",
                                              value: "Request Info",
                                            }
                                          : approvaloption
                                      }
                                      onChange={(e) => {
                                        // setApprovalOption(e.value);
                                        setApprovalOption({
                                          label: e.value,
                                          value: e.value,
                                        });

                                        if (e.value === "Approve") {
                                          let params = {
                                            id: item.id,
                                            status: "VERIFIED",
                                            comments: " ",
                                          };
                                          setAdminCohortAppStatus(params);

                                          setTimeout(() => {
                                            counterList();
                                            getTableDataStatus("APPROVED");
                                            // localStorage.setItem(
                                            //   "cohortApplication",
                                            //   "cohortApplication"
                                            // );

                                            // setApprovalOption({
                                            //   label: "",
                                            //   value: "",
                                            // });
                                            setApprovalOption(null);
                                          }, 2000);
                                        } else if (e.value === "Reject") {
                                          onclickShowSubmitAction(
                                            "Reject",
                                            item.id,
                                            "REJECTED"
                                          );
                                          counterList();
                                        } else if (e.value === "Request Info") {
                                          onclickShowSubmitAction(
                                            "Request Info",
                                            item.id,
                                            "REQUESTINFO"
                                          );
                                          counterList();
                                        } else {
                                          //
                                          // setApprovalOption();
                                        }
                                      }}
                                      options={approvalOptions}
                                      placeholder="Select"
                                    />
                                    <span
                                      className="tooltiptext tooltip-bottom applustar"
                                      style={{
                                        left: "-104px",
                                        top: "-4px",
                                        width: "158px",
                                        height: "46px",
                                      }}
                                    >
                                      Click to Change Application Status
                                    </span>
                                  </>
                                ) : item.applicationStatus === "VERIFIED" ? (
                                  "APPROVED"
                                ) : (
                                  item.applicationStatus
                                )}
                              </div>
                              {item.date_updated &&
                              item.date_updated !== null &&
                              item.date_updated !== ""
                                ? moment(item.date_updated).format("DD/MM/YYYY")
                                : ""}
                              <br></br>
                              {item.date_updated &&
                              item.date_updated !== null &&
                              item.date_updated !== ""
                                ? moment(item.date_updated).format("hh:mm A")
                                : ""}
                            </div>
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                              }}
                            >
                              {item.comments?.length > 75 ? (
                                <>
                                  {item.comments.substring(0, 75)}
                                  <div className="tooltipicon d-flex">
                                    <svg
                                      style={{
                                        position: "relative",
                                        top: "0.1rem",
                                        cursor: "pointer",
                                      }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      className="bi bi-three-dots "
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                    </svg>
                                    <span className="tooltiptext8">
                                      <h5
                                        style={{
                                          fontWeight: 600,
                                          color: "#fff",
                                        }}
                                      >
                                        Comments
                                      </h5>
                                      {item.comments}
                                    </span>
                                  </div>
                                </>
                              ) : item.comments !== null &&
                                item.comments !== "" ? (
                                item.comments
                              ) : (
                                ""
                              )}
                              {}
                            </div>
                          </td>
                          {/* <td>
                            {" "}
                            {item.comments !== null && item.comments !== ""
                              ? item.comments
                              : "NA"}
                          </td> */}
                        </tr>
                      </tbody>
                    ))}
                </table>
                <div className="pagination-box">
                  {getTableDataPaginate !== undefined && (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      //   totalItemsCount={
                      //     startUpApplicationPagineate?.totalElements
                      //   }
                      totalItemsCount={getTableDataPaginate.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
          <div
            className="dashboard-bottom-btn top-btn dashboardbelowBtn newuserTooltip cohortprohgrambutton"
            style={{ margin: "auto" }}
            onClick={() => {
              // history.push({
              //   state: {
              //     fromModule: "startUpApplications",
              //   },
              // });
              localStorage.setItem("cohortProgram", "cohortProgram");
              localStorage.removeItem("cohortApplication");
              window.location.reload();

              history.push({
                pathname: "/dashboard",
                state: {
                  fromModule: "cohortAdminApplication",
                },
              });

              // props.setSelectedMenu("cohortProgram");
              // history.push("/dashboard");
            }}
          >
            <p style={{ cursor: "pointer" }} className="text-white3">
              VIEW COHORT PROGRAMS
            </p>
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "410px", top: "60px", width: "220px" }}
            >
              Click to View Cohort Programs
            </span>
          </div>
        </div>
        {showSubmitAction ? (
          <SubmitAction
            isOpen={showSubmitAction}
            className={"form-submit-modal"}
            onClose={clickOnClose}
            action={action}
            submitData={submitData}
            formName={"cohortApp"}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData: state.MentorReducer.getCohortMentorList.data,
    getTableDataPaginate: state.MentorReducer.getCohortMentorList.paginate,
    getTableCounterData:
      state.AdminMentorReducer.getCohortApplicationCounter.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  //   getStartupApplication,
  //   getCountersStartUpList,
  getPredefineOptionsList,
  getNamesList,
  getMentorCohortApplicationList,
  setAdminCohortAppStatus,
  getCohortApplicationCounter,
  getStepperTooltipData,
})(withRouter(CohortApplication));
